import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useUserPermissions } from '../hooks/useUserPermissions';

interface MarketManagementRouteProps {
  children?: React.ReactNode;
}

export const MarketManagementRoute: React.FC<MarketManagementRouteProps> = ({ children }) => {
  const { hasPermission, isLoading } = useUserPermissions();

  // Show loading while checking permissions
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Check for either market compass admin OR customize permission
  if (!hasPermission('market_compass.admin') && !hasPermission('market_compass.customize')) {
    return <Navigate to="/" replace />;
  }

  return <>{children || <Outlet />}</>;
};
